import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import CountdownStrip from "@/components/CountdownStrip";
import RouteSeo from "@/hooks/RouteSeo";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Commitments from "@/pages/Commitments";
import CommitmentDetail from "@/pages/CommitmentDetail";
import Ward11 from "@/pages/Ward11";
import GetInvolved from "@/pages/GetInvolved";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Donate from "@/pages/Donate";
import PaymentResult from "@/pages/PaymentResult";
import News from "@/pages/News";
import CampaignPost from "@/pages/CampaignPost";
import Questions from "@/pages/Questions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-paper text-ink font-sans">
      <BrowserRouter>
        <ScrollManager />
        <RouteSeo />
        <Navbar />
        <CountdownStrip />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/commitments" element={<Commitments />} />
          <Route path="/commitments/:slug" element={<CommitmentDetail />} />
          <Route path="/ward11" element={<Ward11 />} />
          <Route path="/get-involved" element={<GetInvolved />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/campaign-hq" element={<Admin />} />
          <Route path="/admin" element={<Navigate to="/campaign-hq" replace />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/campaign/:slug" element={<CampaignPost />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/payment/success" element={<PaymentResult mode="success" />} />
          <Route path="/payment/cancel" element={<PaymentResult mode="cancel" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <Toaster richColors position="top-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
